import Types from 'MyTypes';

export const getAuthUser = (state: Types.RootState) => {
    return state.auth.user;
};

export const getBrand = (state: Types.RootState) => {
    return state.auth.brand;
};
